import { createContext } from 'react';

export const InviteGuestContext = createContext();
